<template>
  <div>
    <el-container>
      <el-header
        ><span class="logo">朗新科技</span>
        <el-button type="primary" @click="toLogin">去登录</el-button>
        <el-button type="primary" @click="toRegister">去注册</el-button>
      </el-header>
      <el-main v-html="textHtml"></el-main>
    </el-container>
  </div>
</template>

<script>
import { getPrivacyTextApi } from '../../api/getData'

export default {
  data() {
    return {
      textHtml: ''
    }
  },
  methods: {
    getTest() {
      let Base64 = {
        encode(str) {
          return btoa(
            encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
              return String.fromCharCode('0x' + p1)
            })
          )
        },
        decode(str) {
          return decodeURIComponent(
            atob(str)
              .split('')
              .map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
              })
              .join('')
          )
        }
      }
      getPrivacyTextApi(1).then(res => {
        res = res.data
        console.info(res)
        // 将富文本的base64编码 转换成原来的格式，这个用于将数据库中的富文本展示在界面上
        //let Base64 = require('js-base64').Base64
        let decoded = Base64.decode(res.data)
        console.info(decoded)
        this.textHtml = decoded
      })
    },
    toLogin() {
      this.$router.push({ name: 'login' })
    },
    toRegister() {
      this.$router.push({ name: 'register' })
    }
  },
  mounted() {
    this.getTest()
  }
}
</script>

<style lang="scss" scoped>
.el-button {
  float: right;
  margin-left: 10px;
}

.el-header {
  padding: 30px 150px;
}
.el-main {
  padding: 0 250px;
}
</style>

<style>
.logo {
  font-size: 30px;
  color: #66b1ff;
}
</style>
